import {
  CreatedBy,
  DeliveryStatus,
  ScheduleMode,
} from '../../../../../../views/marketing/push-notifications/Constants';

export default {
  title: 'Campanhas',
  filters: {
    search: 'Pesquisar campanhas...',
  },
  columns: {
    title: 'Título',
    created_by: 'Criado por',
    schedule_mode: 'Modo de agendamento',
    scheduled_at: 'Agendado para',
    sent_at: 'Enviado em',
    status: 'Estado',
    sent: 'Enviado',
    delivered: 'Entregue',
    delivered_rate: 'Taxa de Entrega',
    clicks: 'Cliques',
    click_rate: 'Taxa de cliques',
    live: 'Ativo',
    actions: 'Ações',
  },
  active_status: {
    draft: 'Rascunho',
    active: 'Ativo',
  },
  delivery: {
    in_progress: 'A aguardar confirmação',
    awaiting: 'A aguardar confirmação',
    verified: 'Verificado {{relative}}',
    next_check_around: 'Próxima verificação por volta das {{time}}',
  },
  breakdown: {
    delivered: '{{count}} entregues',
    pending: '{{count}} a aguardar confirmação',
    failed_title: 'Não entregue',
    all_delivered: 'Entregue a todos os destinatários.',
    load_error: 'Não foi possível carregar o resumo de entrega.',
    reasons: {
      DeviceNotRegistered: 'Aplicação removida ou notificações desativadas (token expirado)',
      MessageRateExceeded: 'Temporariamente limitado pela Expo',
      MessageTooBig: 'Conteúdo da notificação demasiado grande',
      MismatchSenderId: 'Credenciais push incompatíveis',
      InvalidCredentials: 'Credenciais push inválidas',
      batch_failed: 'Falha no envio do lote',
      missing_ticket: 'Sem confirmação devolvida pela Expo',
      unknown: 'Erro de entrega desconhecido',
    },
  },
  created_by: {
    [CreatedBy.System]: 'Sistema',
    [CreatedBy.User]: 'Utilizador',
  },
  schedule_mode: {
    [ScheduleMode.Instant]: 'Imediato',
    [ScheduleMode.Scheduled]: 'Agendado',
  },
  delivery_status: {
    [DeliveryStatus.Sending]: 'A enviar',
    [DeliveryStatus.Sent]: 'Enviado',
    [DeliveryStatus.Queued]: 'Em fila',
    [DeliveryStatus.Failed]: 'Falhado',
  },
  actions: {
    details: 'Detalhes',
    view_details: 'Ver detalhes',
    resend: 'Reenviar',
    duplicate_edit: 'Duplicar e editar',
    delete: 'Eliminar',
    edit: 'Editar',
    activate: 'Ativar',
    deactivate: 'Desativar',
  },
  success_messages: {
    campaign_updated: 'Campanha atualizada com sucesso',
    campaign_deleted: 'Campanha eliminada com sucesso',
  },
  error_messages: {
    failed_to_update_campaign: 'Falha ao atualizar a campanha',
    failed_to_load_data: 'Falha ao carregar dados',
    failed_to_delete_campaign: 'Falha ao eliminar a campanha',
  },
};
